// extracted by mini-css-extract-plugin
export default {"page":"PageStub_page__UZ2T8","inner":"PageStub_inner__R7psq","icon":"PageStub_icon__Biw8Q","title":"PageStub_title__RvdOO","sub":"PageStub_sub__NvWHB"};